<main>
  <header>
    <div class="container">
        <div class="row">
            <div class="col-6">
                <img class="header-img  img-fluid" src="../assets/img/sosofa.svg" alt="Imagen 1">
            </div>
            <div class="col-6 d-flex justify-content-end align-items-end">
                <img class="header-img " src="../assets/img/CANAL.svg" alt="Imagen 3">
            </div>
        </div>
    </div>
</header>
  <div class="container">
    <div class="row">
      <div class="col-12 card shadow-sm pt-4 pb-2" style="background-color:#184D9B; color: aliceblue;">

        <h1 class="fw-bold mt-md-3;"> Canal de Denuncias OTIC SOFOFA</h1>
      </div>
      <div class="container">
        <div class="row mb-3 pt-4">
          <div class="col-12 col-md-6">
            <h2 class="fw-bold pb-2">¿Qué es el Canal de Denuncias SOFOFA CAPITAL HUMANO?</h2>
            <p style="
            text-align: justify;">Es una plataforma tecnológica que permite realizar denuncias, es decir, informar
            hechos que podrían constituir delitos, o actos contrarios a la normativa de SOFOFA
            CAPITAL HUMANO y que tiene como objetivo prevenir y corregir aquellas conductas
            que pudieran afectar a la institución y sus colaboradores. Es un sitio seguro, confiable
            y en línea, cuya administración está a cargo del área de Fiscalía y Compliance SOFOFA
            CAPITAL HUMANO, que permite hacer las denuncias de manera anónima o
            identificada.
              <br><br>
              Con este canal, SOFOFA CAPITAL HUMANO quiere potenciar uno de sus principales
            valores, como lo es la Confianza y, al mismo tiempo, mantener el más alto estándar de
            probidad y ética. Por tanto, los invitamos a hacer un uso responsable de este canal.
            </p>

          </div>
          <div class="col-12 col-md-6">
            <h2 class="fw-bold pb-2">¿Quién puede utilizar este canal?
            </h2>
            <p style="
            text-align: justify;">Este canal puede ser utilizado por cualquier trabajador de la corporación o persona
            externa que necesite denunciar un hecho que estime ilícito o contrario a la ley 20.393
            y normativa interna de SOFOFA CAPITAL HUMANO. Ejemplo: robo, hurto, situación de
            acoso o de abuso, falta a la ética. Es importante para la validez de las denuncias,
            acompañar los antecedentes que la respaldan.
              <br><br>
              El canal de denuncias no debe ser utilizado para denunciar sucesos que representan
              una amenaza inmediata a la vida o la propiedad. En dicho caso, contactarse
              directamente con la autoridad local competente. Las denuncias presentadas por esta
              vía NO reciben una respuesta instantánea, ya que éstas requieren un análisis
              minucioso y responsable.
            </p>


          </div>

        </div>


      </div>

      <div class="container d-flex justify-content-end pb-4">
        <button class="btn btn-primary mx-2" (click)="ingresarDenuncia()">Ingresar Denuncia</button>
        <button class="btn btn-primary" (click)="consultarDenuncia()">Consultar
          Denuncia</button>
      </div>

      <!--<div class="col-12 pt-4 pb-4" style="text-align:center;">
        <h4>Para denuncias anónimas se puede utilizar el canal correo electrónico:</h4>
        <a href="" style="text-size:8px !important ; color:#184D9B !important;"><u> denuncias@oticsofofa.cl</u></a>
      </div> -->
    </div>
  </div>
</main>